__turbopack_context__.v({
  "quantitySelectorBox": "QuantitySelector-module__INV4xW__quantitySelectorBox",
  "quantitySelectorButton": "QuantitySelector-module__INV4xW__quantitySelectorButton",
  "quantitySelectorContainer": "QuantitySelector-module__INV4xW__quantitySelectorContainer",
  "quantitySelectorEnabled": "QuantitySelector-module__INV4xW__quantitySelectorEnabled",
  "quantitySelectorLabel": "QuantitySelector-module__INV4xW__quantitySelectorLabel",
});
